export default __webpack_public_path__ + "static/media/d6a6b819169e3cac9ad12e5002d87d51.png";